<template>
  <nav class="block mb-4 text-xs">
    <ol class="breadcrumb-list">
      <li class="breadcrumb-item">
        <router-link :to="{ name: 'index' }" class="hover:underline">首頁</router-link>
      </li>
      <li class="breadcrumb-item">
        <a>{{ title }}</a>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      menuData: [
        { title: '最新優惠', routerName: 'productsList', category: 'recent' },
        { title: '雜誌館', routerName: 'magazine', category: 'magazine' },
        { title: '叢書館', routerName: 'productsList', category: 'book', type: 'BOOK' },
        { title: '套書館', routerName: 'productsList', category: 'package', type: 'PACKAGE' },
        { title: '點讀館', routerName: 'readpen' },
        { title: '數位館', routerName: 'learning' },
        { title: '下載專區', routerName: 'download', category: 'download' }
      ]
    }
  },
  props: {
    title: {
      type: String
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.breadcrumb-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  li {
    letter-spacing: 0.125rem;
    text-transform: uppercase;
    a {
      color: #888;
      text-decoration: none;
      transition: all 0.2s ease;
      &:hover {
        color: #333;
        text-decoration-color: #333;
      }
    }
  }
}
.breadcrumb-item + .breadcrumb-item::before {
    content: "/";
    display: inline-block;
    padding: 0 0.5rem;
    color: #d5d5d5;
}
</style>
